import { KeyRound, ShieldCheck, Coins, HomeIcon, Users, Plane, Wrench, HeartHandshake } from "lucide-react";

const ITEMS = [
  { icon: KeyRound, title: "Real, registered title", body: "Not access. Not a club. Your name on a deed, with all the protections that come with it." },
  { icon: ShieldCheck, title: "Governed by constitution", body: "A signed framework written by reputable Israeli counsel — clarity from day one." },
  { icon: Coins, title: "Lower entry, shared costs", body: "Own 25–50% instead of 100%. Fees, taxes and upkeep split fairly and transparently." },
  { icon: HomeIcon, title: "Turnkey & furnished", body: "Ready to live in from day one. Prefer to make it yours? We can organise remodelling, furniture, finishes and styling — all curated, all handled." },
  { icon: Users, title: "Curated co‑owners", body: "Matched on values, observance, family rhythm and budget. No surprises, no friction." },
  { icon: Plane, title: "Guaranteed usage", body: "Defined windows for Pesach, summer, the Chagim — rotated fairly, year after year." },
  { icon: Wrench, title: "Five‑star management", body: "Maintenance, cleaning, changeovers, bills, taxes, bookings and rentals — handled." },
  { icon: HeartHandshake, title: "A legacy for your children", body: "Diversified assets, a currency hedge, and a home that ties the next generation to Israel." },
];

export default function Benefits() {
  return (
    <section data-testid="benefits-section" className="relative bg-[var(--bone-soft)] text-[var(--ink)]">
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-24 md:py-36 lg:py-40">
        <div className="max-w-3xl reveal">
          <div className="text-overline text-[var(--ink)]/55 mb-6">Why families choose us</div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight">
            Every detail, <span className="italic text-[var(--gold)]">handled with care.</span>
          </h2>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--border-soft)] border border-[var(--border-soft)]">
          {ITEMS.map((it, i) => (
            <div
              key={it.title}
              data-testid={`benefit-${i}`}
              className="bg-[var(--bone)] p-8 md:p-10 flex flex-col gap-5 reveal"
              style={{ transitionDelay: `${(i % 4) * 0.07}s` }}
            >
              <it.icon className="h-6 w-6 text-[var(--gold)]" strokeWidth={1.6} />
              <h3 className="font-serif-display text-2xl md:text-[1.6rem] leading-tight tracking-tight">
                {it.title}
              </h3>
              <p className="text-[var(--ink)]/65 text-sm md:text-base leading-relaxed font-light">
                {it.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
